/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  permitsList,
  minPermisos,
  generalTitles,
} from '../../../constants/index';
import PolygonsTable from '../../../components/sharedComponents/Tablas/index';
import CardTitle from '../../../components/sharedComponents/CardTitle';
import PoperComponent from '../../../components/sharedComponents/Popover';
import useInputValue from '../../../utils/hooks/useInputValue';
import Card from '../../../components/sharedComponents/Card/Card';
import CardHeader from '../../../components/sharedComponents/Card/CardHeader';
import CardBody from '../../../components/sharedComponents/Card/CardBody';
import Search from '../../../components/sharedComponents/SearchInput';
import { useStyles } from './styles';
import canUseState from '../../../utils/canUseState';

const BossesPage = (props) => {
  const {
    territorios = [],
    jefes = [],
    jefesTerritorios = [],
    searchBosses,
    search,
    select,
    permisos,
    onCreateBosses,
    hadleSearchBoss,
    handleDeleteTable,
    handleCreate,
    handleSearch,
    handleDelete,
    handleSelect,
    handleUpdate,
  } = props;

  const classes = useStyles();
  const inputValue = useInputValue('');
  const inputEdit = useInputValue('');
  const [edit, setEdit] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const create = open ? 'simple-popover' : undefined;

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(!anchorEl);
  };

  const onCreate = (event) => {
    event.preventDefault();
    setAnchorEl(null);
    onCreateBosses({
      value: inputValue.value,
    });
  };

  const onUpdate = (event) => {
    event.preventDefault();
    setAnchorEl(null);
    setEdit(!edit);
    handleUpdate({
      nombre: inputEdit.value,
      id: select?.id,
      unidad_negocio_id: jefesTerritorios[0]?.unidad_negocio_id,
    });
  };

  const columnsPolygonsBosses = [
    { title: 'Jefe', field: 'jefe' },
    { title: 'Jefe_id', field: 'jefe_id', hidden: true },
    { title: 'Territorio', field: 'territorio' },
    { title: 'Tid', field: 'territorio_id', hidden: true },
    { title: 'Unidad N', field: 'unit', hidden: true },
  ];

  return (
    <>
      <CardTitle
        title={generalTitles.TITLE_BOSSES}
        subTitle={generalTitles.SUB_TITLE_CARD}
      />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Card>
            <CardHeader>
              <Grid container>
                <Grid item xs={12} sm={5}>
                  <h3>{generalTitles.BOSSES}</h3>
                  <p>Seleccione un jefe</p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Tooltip title={generalTitles.ADD} aria-label="add">
                    <Fab
                      onClick={handleOpenPopover}
                      size="medium"
                      color="primary"
                      aria-label="add"
                    >
                      <AddIcon />
                    </Fab>
                  </Tooltip>
                  <PoperComponent
                    handleUpdate={onCreate}
                    handleClose={handleClose}
                    inputValue={inputValue}
                    className={classes.popover}
                    anchorEl={anchorEl}
                    title={generalTitles.NEW}
                    open={open}
                    id={create}
                  />
                </Grid>
              </Grid>
              <Search handleSearch={hadleSearchBoss} search={searchBosses} />
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {jefes && jefes?.map((item) => (
                <div key={item.id}>
                  <Chip
                    id={item.id}
                    label={item.nombre.toUpperCase()}
                    clickable
                    className={classes.chip}
                    color="primary"
                    deleteIcon={(
                      <DeleteIcon
                        className={classes.tableActionButtonIcon}
                        style={{ color: '#f44336 ' }}
                      />
                    )}
                    variant="outlined"
                    onDelete={
                      permisos[permitsList.ADMIN_JEFES] >= minPermisos.ELIMINAR
                        ? handleDelete(item)
                        : null
                    }
                    onClick={handleSelect(item)}
                  />
                </div>
              ))}
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Grid container>
                <Grid item sm={6}>
                  <p>{generalTitles.TITLE_TERRITORY}</p>
                </Grid>
                <Grid item sm={6}>
                  {select && (
                    <>
                      <p>Territorio Seleccionado</p>
                      <Chip
                        avatar={<Avatar>B</Avatar>}
                        label={select.nombre}
                        clickable
                        className={classes.chip}
                        color="primary"
                        deleteIcon={(
                          <EditIcon
                            className={classes.tableActionButtonIcon}
                            style={{ color: ' #4CAF50' }}
                          />
                        )}
                        variant="outlined"
                        style={{ width: '100%' }}
                        onClick={() => setEdit(!edit)}
                        onDelete={
                          permisos[permitsList.ADMIN_JEFES]
                          >= minPermisos.ACTUALIZAR
                            ? () => setEdit(!edit)
                            : null
                        }
                      />
                      {edit && (
                        <Paper
                          component="form"
                          onSubmit={onUpdate}
                          className={classes.paper}
                        >
                          <InputBase
                            className={classes.input}
                            placeholder={select.nombre}
                            inputProps={{ 'aria-label': `${select.nombre}` }}
                            {...inputEdit}
                          />
                          <IconButton
                            type="submit"
                            className={classes.iconButton}
                            aria-label="search"
                          >
                            <SaveIcon />
                          </IconButton>
                          <IconButton
                            type="onClick"
                            onClick={() => setEdit(!edit)}
                            className={classes.iconButton}
                            aria-label="search"
                          >
                            <CancelIcon />
                          </IconButton>
                        </Paper>
                      )}
                    </>
                  )}
                </Grid>
              </Grid>
              <Search handleSearch={handleSearch} search={search} />
            </CardHeader>
            <CardBody className={classes.cardBody}>
              {territorios
                && territorios?.map((item) => {
                  const canUse = canUseState(
                    jefesTerritorios,
                    item,
                    'territorio_id',
                    'id',
                  );
                  return (
                    <div key={item.id}>
                      <Chip
                        avatar={(
                          <Avatar className={classes.avatar}>
                            {item.territorio.charAt(0)}
                          </Avatar>
                        )}
                        label={item.territorio.toUpperCase()}
                        clickable
                        className={classes.chip}
                        color={!canUse ? 'default' : 'primary'}
                        onClick={handleCreate({ ...item, jefe_id: select.id })}
                        disabled={!select}
                      />
                    </div>
                  );
                })}
            </CardBody>
          </Card>
        </Grid>
      </div>
      {/*= =======================================================================
        Tabla Territorios
        ======================================================================== */}
      <PolygonsTable
        columns={columnsPolygonsBosses}
        dataTable={jefesTerritorios}
        idPermisoTabla={permitsList.ADMIN_JEFES_TERRITORIOS}
        onDeleteTable={handleDeleteTable}
        titleTable={generalTitles.TITLE_TABLE_BOSSES}
        hiddenEdit
        hiddenDelete={false}
      />
    </>
  );
};

export default memo(BossesPage);
